/* KDOT Collections theme scripts */
(function () {
  'use strict';
  var K = window.KDOT || {};
  var html = document.documentElement;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money formatting (for variant price updates) ---------- */
  function formatMoney(cents) {
    var fmt = K.moneyFormat || '{{amount}}';
    function digits(n, p, t, d) {
      p = p == null ? 2 : p; t = t || ','; d = d || '.';
      if (isNaN(n) || n == null) return '0';
      var s = (n / 100).toFixed(p).split('.');
      return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (s[1] ? d + s[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return digits(cents, 2);
        case 'amount_no_decimals': return digits(cents, 0);
        case 'amount_with_comma_separator': return digits(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return digits(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return digits(cents, 2, "'", '.');
        default: return digits(cents, 2);
      }
    });
  }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3000);
  }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); html.classList.add('no-scroll');
    var x = $('.drawer-x', d); if (x) x.focus();
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    html.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var op = t.closest('[data-drawer-open]');
    if (op) { e.preventDefault(); openDrawer(op.getAttribute('data-drawer-open')); return; }
    if (t.closest('[data-drawer-close]')) { closeDrawers(); return; }
    var co = t.closest('[data-cart-open]');
    if (co && K.cartDrawer) { e.preventDefault(); openDrawer('cart-drawer'); return; }
    var st = t.closest('[data-search-toggle]');
    if (st) {
      var panel = document.getElementById('search-panel'); var open = panel.hidden;
      panel.hidden = !open; st.setAttribute('aria-expanded', String(open));
      if (open) { var i = $('input[type=search]', panel); if (i) i.focus(); }
      return;
    }
    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = $('input', step.parentNode); if (!input) return;
      var min = input.min === '' ? 1 : +input.min; var max = input.max === '' ? 99 : +input.max;
      input.value = Math.max(min, Math.min(max, (+input.value || 0) + (+step.getAttribute('data-qty-step'))));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var lq = t.closest('[data-line-qty]');
    if (lq) { e.preventDefault(); changeLine(+lq.getAttribute('data-line'), +lq.getAttribute('data-qty')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawers();
      var panel = document.getElementById('search-panel');
      if (panel && !panel.hidden) { panel.hidden = true; var b = $('[data-search-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); }
    }
  });

  /* ---------- cart ---------- */
  function setBubble(n) {
    $$('[data-cart-bubble]').forEach(function (b) { b.textContent = n; b.hidden = n < 1; });
  }
  function refreshDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = $('[data-drawer-inner]', doc), cur = $('#cart-drawer [data-drawer-inner]');
    if (!fresh || !cur) return;
    cur.innerHTML = fresh.innerHTML;
    var c = $('[data-cart-count]', cur); if (c) setBubble(+c.textContent || 0);
  }
  function changeLine(line, qty) {
    fetch(K.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.status) { toast(d.description || d.message || 'Could not update your bag.'); return; }
      refreshDrawer(d.sections);
    }).catch(function () { window.location.href = K.cartUrl; });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-ajax-cart]') || !K.cartDrawer) return;
    e.preventDefault();
    var btns = $$('button[type=submit]', f);
    if (f.id) btns = btns.concat($$('button[form="' + f.id + '"]'));
    var labels = btns.map(function (b) { return b.textContent; });
    btns.forEach(function (b) { b.disabled = true; if (b.hasAttribute('data-add-btn')) b.textContent = 'Adding...'; });
    var errBox = $('[data-form-error]', f); if (errBox) errBox.hidden = true;

    var fd = new FormData(f);
    fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname);
    fetch(K.cartAddUrl + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || res.d.status) {
          var msg = res.d.description || res.d.message || 'Could not add this item.';
          if (errBox) { errBox.textContent = msg; errBox.hidden = false; } else { toast(msg); }
        } else {
          refreshDrawer(res.d.sections); openDrawer('cart-drawer');
        }
      })
      .catch(function () { f.removeAttribute('data-ajax-cart'); f.submit(); })
      .then(function () { btns.forEach(function (b, i) { b.disabled = false; b.textContent = labels[i]; }); });
  });

  /* ---------- header shadow ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.style.boxShadow = window.scrollY > 8 ? '0 10px 30px -22px rgba(0,0,0,.25)' : 'none'; };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var dataEl = $('[data-product-json]', root); if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = $('.pform', root); var idInput = $('input[name=id]', form);
    var addBtns = $$('[data-add-btn]', root);
    var prices = $$('[data-price]', root); var saleBadge = $('[data-sale-badge]', root);

    function setBtns(label, disabled) { addBtns.forEach(function (b) { b.textContent = label; b.disabled = disabled; }); }

    function update(user) {
      var sel = $$('[data-option]', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      $$('[data-option]', root).forEach(function (fs) { var c = $('input:checked', fs), o = $('[data-option-value]', fs); if (c && o) o.textContent = c.value; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!v) { idInput.value = ''; setBtns('Unavailable', true); return; }
      idInput.value = v.id;
      setBtns(v.available ? 'Add to bag' : 'Sold out', !v.available);
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      prices.forEach(function (p) {
        var big = p.closest('.product-price');
        p.className = 'price' + (sale ? ' price--sale' : '');
        p.innerHTML = (sale && big ? '<s class="price-was">' + formatMoney(v.compare_at_price) + '</s> ' : '') + '<span class="price-now">' + formatMoney(v.price) + '</span>';
      });
      if (saleBadge) saleBadge.hidden = !sale;
      if (user) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        if (v.featured_media) {
          var m = $('[data-media-id="' + v.featured_media.id + '"]', root);
          if (m) m.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      }
    }
    $$('[data-option] input', root).forEach(function (i) { i.addEventListener('change', function () { update(true); }); });
    update(false);

    var sticky = $('[data-sticky-atc]', root), mainBtn = $('.buy-row [data-add-btn]', root);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(mainBtn);
    }
  }
  $$('[data-product-section]').forEach(initProduct);

  /* ---------- recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url'); if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (txt) {
      var doc = new DOMParser().parseFromString(txt, 'text/html');
      var fresh = $('[data-recs]', doc);
      if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML; else el.setAttribute('data-empty', '');
    }).catch(function () { el.setAttribute('data-empty', ''); });
  });

  /* ---------- collection filters ---------- */
  $$('[data-filter-form]').forEach(function (f) {
    f.addEventListener('change', function () { f.submit(); });
  });

  /* ---------- policy tabs ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var tabs = $$('[data-tab]', wrap);
    function show(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
        document.getElementById('panel-' + t.getAttribute('data-tab')).hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (!k) return; e.preventDefault();
        var n = tabs[(i + k + tabs.length) % tabs.length]; show(n); n.focus();
      });
    });
  });
})();
